const orderOptimizerRoutesUrls = {
  listing: `/order-optimizer`,
  details: `/order-optimizer/:id/details/:excludedOrders`,
};

export default orderOptimizerRoutesUrls;
